export default __webpack_public_path__ + "8f2c4d11474275fbc1614b9098334eae.png";